import HeroSection from '@/components/HeroSection';
import LogoSection from '@/components/LogoSection';
import SignalSection from '@/components/SignalSection';
import ThreeWaysSection from '@/components/ThreeWaysSection';
import GuideSection from '@/components/GuideSection';
import FrameworkSection from '@/components/FrameworkSection';
import QuizSection from '@/components/QuizSection';
import CTASection from '@/components/CTASection';

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <LogoSection />
      <SignalSection />
      <ThreeWaysSection />
      <GuideSection />
      <FrameworkSection />
      <QuizSection />
      <CTASection />
    </main>
  );
}
